import React from "react";
import { VariantBase } from "~/components/newsletter/newsletter-widget/variants/component";
import { Container, theme } from "./styles";
export { config as newsletterArticleThemeConfig } from "./config";
export const NewsletterArticleTheme = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(VariantBase, {
  theme: theme,
  "data-qa": "newsletter-article-theme"
}, /*#__PURE__*/React.createElement(Container, props, children));
NewsletterArticleTheme.displayName = "NewsletterArticleTheme";